import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  fill: "none",
  viewBox: "0 0 254 254"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "254",
      height: "254",
      fill: "#017737",
      rx: "127"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M196.68 105.85c0 34.36-22.17 57.86-53.87 57.86-15.07 0-27.49-6.21-32.14-13.97l.22 7.98v49.21H78.53V79.69c0-1.77-.44-2.22-2.44-2.22H65V50.43h27.05c12.41 0 15.52 10.64 16.4 15.3 4.88-8.2 17.73-17.73 35.91-17.73 31.26-.01 52.32 23.26 52.32 57.85m-33.03.22c0-18.4-11.97-31.03-27.05-31.03-12.41 0-26.38 8.2-26.38 31.26 0 15.07 8.42 30.81 25.94 30.81 12.86-.01 27.49-9.32 27.49-31.04"
    }, null, -1)
  ])))
}
export default { render: render }